export default {"src":"/_next/static/media/search-header-icon.32b9ef02.svg","height":16,"width":17,"blurWidth":0,"blurHeight":0};